define('toggleMoreOnBands',['jquery'], function($) {
	$.fn.toggleBand = function (options) {
		
		if ($("body[data-isPageEdit]").length > 0) {
			return;
		}
		
		this.each(function () {
			var $this = $(this);
			var $showmoreLink = $this.find("[data-showmore]");
			var $showlessLink = $this.find("[data-showless]");

			$showlessLink.hide();

			$showmoreLink.click(function(event) {
				event.preventDefault();

				var moreContent = $this.parents(".spot").find(".more");

				$showlessLink.show();
				$showmoreLink.hide();

				moreContent.slideDown( {
                    // Masonry resources layout trigger, when slideDown begins
                    start: function () {
                        if (moreContent.hasClass("more--masonry")) {
                            moreContent.find(".masonry-grid").trigger("updateLayout");
                        }
                    }
                });
			});

			$showlessLink.click(function(event) {
				event.preventDefault();
				var more =$this.parents(".spot").find(".more");
				var toprow = more.closest(".spot").offset().top;
				$showlessLink.hide();
				$showmoreLink.show();
				more.slideUp();
				$('html, body').stop().animate({
					scrollTop: toprow - 100,
					easing: "swing"
				}, 400);
			});
		});
	};
});

